import { useEffect } from 'react';
// mui
import { Box, Stack, useTheme } from '@mui/material';
// components
import AccountPopover from '@/layouts/dashboard/header/AccountPopover';
import Searchbar from '@/layouts/dashboard/header/Searchbar';
import { NotificationsPopover } from '@/features/notification/components';
//
import { RightSidebarIcon } from '.';
// redux
import { dispatch, useSelector } from '@/stores';
import { setSelectedMenubarIconId } from '../slices';
// hooks + utils
import useAuth from '@/hooks/useAuth';
import {
  RIGHT_SIDEBAR_MENU_OPTIONS,
  shouldHideRightSidebarMenuOption,
} from '../utils';
import { RIGHT_SIDEBAR } from '@/config';
import { useCustomChatChannels } from '@/features/custom-chat/hooks';
import { updateCustomChatUnreadMessages } from '@/features/custom-chat/slices';
import { useGetAccess } from '@/hooks/useAccess';
// types

export default function RightSidebar() {
  const theme = useTheme();
  const { isSuperAdmin, user } = useAuth();
  const chatAccess = useGetAccess('chat');
  const { selectedMenubarIconId } = useSelector((state) => state.rightSideBar);
  const customChatChannelsQuery = useCustomChatChannels(chatAccess.canView);

  const handleIconClick = (id: number) => {
    const idToSend = selectedMenubarIconId === id ? 0 : id;
    dispatch(setSelectedMenubarIconId(idToSend));
  };

  useEffect(() => {
    const channels = customChatChannelsQuery.data ?? [];
    const unreadCount = channels.reduce(
      (total, channel) => total + Number(channel.unread_count ?? 0),
      0
    );

    dispatch(updateCustomChatUnreadMessages({ unreadCount }));
  }, [customChatChannelsQuery.data]);

  return (
    <Box
      sx={{
        bgcolor: (theme) =>
          theme.palette.mode === 'light'
            ? theme.palette.grey[200]
            : theme.palette.grey[800],
        zIndex: theme.zIndex.appBar + 2,
        position: 'sticky',
        top: 0,
        right: 0,
        height: '100vh',
        width: RIGHT_SIDEBAR.BASE_WIDTH,
      }}
    >
      <Stack spacing={1} alignItems={'center'} sx={{ pt: 2 }}>
        <AccountPopover />
        <NotificationsPopover />
        <Searchbar />
      </Stack>
      <Stack
        sx={{ pt: 2 }}
        direction="column"
        alignItems="center"
        justifyContent="center"
        spacing={1}
      >
        {RIGHT_SIDEBAR_MENU_OPTIONS.map((menuOption) => (
          <RightSidebarIcon
            key={menuOption.id}
            id={menuOption.id}
            title={menuOption.title}
            icon={menuOption.icon}
            slug={menuOption.slug}
            onClick={() => handleIconClick(menuOption.id)}
            hideIcon={shouldHideRightSidebarMenuOption(menuOption.slug, {
              canViewChat: chatAccess.canView,
              hasChatToken: Boolean(user?.chat_token),
              isSuperAdmin,
            })}
          />
        ))}
      </Stack>
    </Box>
  );
}
